module.exports = __webpack_public_path__ + "static/media/textediter_underline.d75f6c5e.svg";